import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';

const WelcomeModal = ({ isOpen, onClose }) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="sm"
      classNames={{
        base: "bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 border border-gray-100 dark:border-gray-800",
        backdrop: "bg-black/50",
        header: "text-gray-900 dark:text-gray-100",
        body: "text-gray-800 dark:text-gray-200",
        footer: "border-t border-gray-100 dark:border-gray-800"
      }}
      motionProps={{
        initial: { opacity: 0, y: -20 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 20 },
        transition: { duration: 0.15 }
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="text-primary font-bold dark:text-white">Welcome to Finalism</ModalHeader>
            <ModalBody className="text-gray-800 dark:text-gray-200">
              <div className="space-y-4">
                <p className="text-sm text-gray-700 dark:text-gray-200">
                  This app helps you find available rooms during KFUPM's final exam period.
                </p>
                
                <div className="border-l-4 border-primary pl-3 py-2 bg-gray-50 dark:bg-gray-800 rounded-md ring-1 ring-gray-100 dark:ring-gray-800">
                  <h3 className="font-semibold mb-1 text-sm text-gray-800 dark:text-gray-100">Check Room Availability</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    Enter building and room numbers to see if they're available.
                  </p>
                </div>
                
                <div className="border-l-4 border-primary pl-3 py-2 bg-gray-50 dark:bg-gray-800 rounded-md ring-1 ring-gray-100 dark:ring-gray-800">
                  <h3 className="font-semibold mb-1 text-sm text-gray-800 dark:text-gray-100">Explore Exam Schedule</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300">
                    Browse the complete exam timetable with multiple filters.
                  </p>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button 
                className="bg-primary text-white hover:bg-primary-hover"
                onPress={onClose}
                size="sm"
                disableAnimation
              >
                Get Started
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default WelcomeModal;